import React from "react";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { useStyles } from "./styles";

export default function Step4Professionals({ professionals, addProfessional, removeProfessional, updateProfessional }) {
  const c = useStyles();
  return (
    <>
      <Typography variant="h6" gutterBottom>Profesionales</Typography>
      {professionals.map((p, idx) => (
        <div key={idx} className={c.inlineRow}>
          <TextField size="small" label="Nombre" value={p.name} onChange={(e) => updateProfessional(idx, "name", e.target.value)} style={{ minWidth: 160 }} />
          <TextField size="small" label="Rol" value={p.roleLabel || ""} onChange={(e) => updateProfessional(idx, "roleLabel", e.target.value)} style={{ minWidth: 120 }} />
          <TextField size="small" label="Especialidad" value={p.specialty || ""} onChange={(e) => updateProfessional(idx, "specialty", e.target.value)} style={{ minWidth: 140 }} />
          <IconButton size="small" onClick={() => removeProfessional(idx)} disabled={professionals.length <= 1}><DeleteIcon /></IconButton>
        </div>
      ))}
      <Button startIcon={<AddIcon />} onClick={addProfessional} color="primary">Agregar profesional</Button>
    </>
  );
}
